import { useMemo } from 'react';

import { BasicBadge } from './BasicBadge';
import { BadgeType } from './enums';

interface IFilledBadgeProps {
  readonly text: string;
  readonly type?: BadgeType;
}

export function FilledBadge({ text, type }: IFilledBadgeProps) {
  const badgeStyle = useMemo(() => {
    switch (type) {
      case BadgeType.Error:
        return 'border-error bg-error text-white';
      case BadgeType.Info:
        return 'border-silver bg-silver text-gray';
      case BadgeType.Primary:
      default:
        return 'border-primary bg-primary text-white';
    }
  }, [type]);

  return <BasicBadge extraClassName={badgeStyle}>{text}</BasicBadge>;
}
